import ScriptingEffect from './ScriptingEffect.js';
import {pipe} from './pipe.js';
import {gate} from './beat.js';
import {
    switchOutput,
    execute,
    rolling,
    notes,
    steps,
    prob,
    cond
} from './lang.js';

class GateEffect extends ScriptingEffect {
    constructor(track) {
        super("Midi Gate", track);
        this.clear();

        this.numberOfOutputs = 2;
        this.newVar('steps', new Array(16).fill(1), 0, 65536);
    }

    clear() {
        this.myScript = pipe(
            gate(this.var('steps')));
    }

    get script() {
        return this.myScript;
    }

    getCopy(track, ignoreId=true) {
        let fx = new GateEffect(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}


export default GateEffect;
